$('.sidebar-nav-collapse').each(function () {
  let $this = $(this);
  let $toggleBtn = $this.find('.sidebar-nav-collapse__header');
  let $collapse = $this.find('.collapse');
  if ($toggleBtn.hasClass('expanded')) $collapse.addClass('show');
  $toggleBtn.on('click', () => $collapse.collapse('toggle'));
  $collapse
    .on('show.bs.collapse', function () {
      $toggleBtn.addClass('expanded');
    })
    .on('hide.bs.collapse', function () {
      $toggleBtn.removeClass('expanded');
    });
});

let $activeItem = $('.sidebar-nav-item--active');
if ($activeItem.length === 1) {
  $activeItem
    .closest('.sidebar-nav-collapse')
    .find('.sidebar-nav-collapse__header')
    .addClass('text-primary');
}
